import { AttachmentError } from '../Error'
import { AttachmentInfo } from '../Info'
import { AttachmentLoading } from '../Loading'
import { useAttachmentCardStore } from '../Store/hooks/useStore'

export const AttachmentCore = () => {
  const { error, loading } = useAttachmentCardStore(state => state)

  if (loading) {
    return <AttachmentLoading />
  }

  if (error) {
    return <AttachmentError />
  }

  return <AttachmentInfo />
}
